import type { EntityRegistryEntry } from '../types';

export const employeeConfig: EntityRegistryEntry = {
    fetchAttributes: ['Id', 'DisplayName', 'Email', 'UserPrincipalName', 'Department', 'JobTitle'],
    listColumns: () => [
        {
            key: 'role',
            label: 'Role',
            sortable: true,
            render: (entity: any) => entity.Role || 'N/A'
        }
    ]
};
